module.exports = __webpack_public_path__ + "static/media/E13.3c540724.jpg";